









import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class PublicHeaderNav extends Vue {
    private ecx_logo_image = require('@/assets/EconomX logo - on light bg.svg');

    created() {
        console.log('asdfasd')
    }
}
